import { gsap } from "gsap/dist/gsap";
gsap.registerPlugin(Draggable)
import { Draggable } from "gsap/dist/Draggable";

var sectionSlider = document.querySelectorAll(".section-slider");
var slideDelay = 7;
var slideDuration = 1.4;
var wrap = true;
var proxies = [];
var slidesArray = [];

var progressWrap = gsap.utils.wrap(0, 1);

var sectionSliderNum = sectionSlider.length;
for (let i = 0; i < sectionSliderNum; i++){
var proxy = document.createElement("div");
var slides = sectionSlider[i].querySelectorAll(".slide");
proxies[i] = proxy;
slidesArray[i] = slides;
}

//console.log(slidesArray);

for (let i = 0; i < sectionSliderNum; i++){

var slides = sectionSlider[i].querySelectorAll(".slide");

var slidesInner = sectionSlider[i].querySelectorAll(".slides-inner");
var prevButton = sectionSlider[i].querySelector(".prevButton");
var nextButton = sectionSlider[i].querySelector(".nextButton");

var numSlides =  sectionSlider[i].getElementsByClassName("slide").length;


new ResizeObserver(resize);

gsap.set(slides, {
  //backgroundColor: "random([white])",
  xPercent: i => i * 100
});

if(slides.length !== 1){
  // console.log('over 1');
var wrapX = gsap.utils.wrap(-100, (numSlides - 1) * 100);
}else{
  // console.log('less than 1');
  var wrapX = gsap.utils.wrap(0, (numSlides - 1) * 100);
}

var timer = gsap.delayedCall(slideDelay, autoPlay);

var animation = gsap.to([slidesArray[i]], {
  xPercent: "+=" + (numSlides * 100),
  duration: 1,
  ease: "none",
  paused: true,
  repeat: -1,
  modifiers: {
    xPercent: wrapX
  }
});


var slideAnimation = gsap.to({}, {});
var slideWidth = 0;
var wrapWidth = 0;

/*
var draggable = new Draggable(proxy, {
  trigger: ".slides-container",
  inertia: true,
  onPress: updateDraggable,
  onDrag: updateProgress,
  onThrowUpdate: updateProgress,
  snap: {     
    x: snapX
  }
});
*/

resize();

window.addEventListener("resize", resize);

prevButton.addEventListener("click", function() {
  animateSlides(1);
});

nextButton.addEventListener("click", function() {
  animateSlides(-1);
});

/*
function updateDraggable() {
  timer.restart(true);
  slideAnimation.kill();
  this.update();
}
*/

function animateSlides(direction) {
  timer.restart(true);
  slideAnimation.kill();
  var slideVal = gsap.getProperty(proxies[i], "x") + direction * slideWidth;
  //console.log(slideVal);
  var x = snapX(slideVal);
  // console.log(proxies[i]);
  slideAnimation = gsap.to(proxies[i], {
    x: x,
    duration: slideDuration,
    onUpdate: updateProgress
  });  
}

function autoPlay() {  
    animateSlides(-1);
}

function updateProgress() { 
  animation.progress(progressWrap(gsap.getProperty(proxies[i], "x") / wrapWidth));
}

function snapX(value) {
  let snapped = gsap.utils.snap(slideWidth, value);
  //var re = wrap ? snapped : gsap.utils.clamp(-slideWidth * (numSlides - 1), 0, snapped);
  //console.log(re);
  var re = wrap ? snapped : gsap.utils.clamp(-slideWidth * (numSlides - 1), 0, snapped);
  return re;
}

function resize() {

  var norm = (gsap.getProperty(proxies[i], "x") / wrapWidth) || 0;
  
  slideWidth = slides[0].offsetWidth;
  wrapWidth = slideWidth * numSlides;
  
  wrap || draggable.applyBounds({minX: -slideWidth * (numSlides - 1), maxX: 0});
  
  gsap.set(proxies[i], {
    x: norm * wrapWidth
  });
  
  animateSlides(0);
  slideAnimation.progress(1);
}
}